import React, { useEffect, useState } from "react";
import "./CarItem.css";
import { useNavigate, useParams } from "react-router";
import { Car } from "../Types/Car";
import ImageManager from "./ImageManager";
import CarInformation from "./CarInformation";
import RightSidebar from "../Utilities/RightSidebar";
import PersonCard from "../SalesPerson/PersonCard";
import axios from "axios";
import { apiBaseUrl } from "../../constants/config";
import { useIsMobile } from "../Utilities/useIsMobile";
import { IconType } from "react-icons";
import { IoMdPerson } from "react-icons/io";
import { FaWhatsapp } from "react-icons/fa";
import { FaPhone } from "react-icons/fa";
import { LuMessageCircleMore } from "react-icons/lu";
import { FaPhoneVolume } from "react-icons/fa6";
import { IoMdArrowBack } from "react-icons/io";

// react-icons components return ReactNode, which the project's TypeScript
// version does not accept as a JSX element; cast once here instead of at
// every call site
const Icon: React.FC<{ of: IconType }> = ({ of }) => {
  const IconComponent = of as React.ComponentType;
  return <IconComponent />;
};
interface CarItemProps {
  contactDataUser?: any;
}
const CarItem: React.FC<CarItemProps> = ({contactDataUser}) => {
  const { id } = useParams<{ id: string }>();
  const [car, setCar] = useState({} as Car);
  const isMobile = useIsMobile(1050);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    getCarById(id);
  }, [id]);

  const getCarById = async (carId: string | undefined) => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(`${apiBaseUrl}/cars/${carId}`);
      setCar(response.data);
    } catch (error) {
      console.error("Error fetching cars", error);
      setError(true);
    }
    finally {
      setLoading(false);
    }
  };

  const convertUserToPerson = (user: any) => {
    return {
      name: [user.firstName, user.lastName].filter(Boolean).join(" ") || "Myyjä",
      title: user.title || "Myyjä",
      email: user.email,
      phone: user.phone || "ei puhelinnumeroa",
      imageUrl: user.image || null,
    };
  };

  const hasValidUser = (user: any) => {
    return user && (user?.firstName || user?.lastName || user?.email || user?.phone);
  };

  const contactWhatsapp = (user: any) => {
    if (!user || !user.phone) return;
    const phoneNumber = user.phone.replace(/\D/g, ""); // Remove non-digit characters
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl, "_blank");
  };

  const contactCall = (user: any) => {
    if (!user || !user.phone) return;
    const phoneNumber = user.phone.replace(/\D/g, ""); // Remove non-digit characters
    const telUrl = `tel:${phoneNumber}`;
    window.open(telUrl, "_self");
  };

  const contactEmail = (user: any) => {
    if (!user || !user.email) return;
    const emailAddress = user.email;
    const mailtoUrl = `mailto:${emailAddress}`;
    window.open(mailtoUrl, "_self");
  };

  const renderIcon = (icon: "person" | "phone" | "back") => {
    if (icon === "person") {
      return <Icon of={IoMdPerson} />;
    }
    if (icon === "phone") {
      return <Icon of={FaPhoneVolume} />;
    }
    if (icon === "back") {
      return <Icon of={IoMdArrowBack} />;
    }
  };
  const renderButtonIcon = (icon: "wapp" | "phone" | "message") => {
    if (icon === "wapp") {
      return <Icon of={FaWhatsapp} />;
    }
    if (icon === "phone") {
      return <Icon of={FaPhone} />;
    }
    if (icon === "message") {
      return <Icon of={LuMessageCircleMore} />;
    }
  };

  if (loading) {
    return <div className="car-item-container">
    <div className="loading"></div>
    </div>
  }

  if (error) {
    return (
      <div className="car-item-container">
        <div className="car-item-error">
          <p>Autoa ei löytynyt tai sen lataaminen epäonnistui.</p>
          <div className="back-button" onClick={() => navigate("/cars")}>
            {renderIcon("back")} Takaisin listaukseen
          </div>
        </div>
      </div>
    );
  }

  const shownUser = hasValidUser(car.user) ? car.user : contactDataUser;
  return (
    <>
      <div className="car-item-container">
        {isMobile && (
          <div className="back-button" onClick={() => navigate("/cars")}>
            {renderIcon("back")} Takaisin listaukseen
          </div>
        )}
        {car.images && car.images.length > 0 && (
          <ImageManager images={car.images} />
        )}
        {isMobile && (
            <RightSidebar>
          <div className="car-card-content right-sidebar">
            <div className="back-button" onClick={() => navigate("/cars")}>
              {renderIcon("back")} Takaisin listaukseen
            </div>
            <div className="car-card-header">
              <div className="car-card-title">
                <div className="car-card-make-model">
                  {car.make} {car.model}
                </div>
                <div className="car-card-year">{car.yearOfRegistration}</div>
              </div>
              <div className="car-card-description">{car.modelTypeName}</div>
            </div>
            <div className="car-card-items">
              <p className="content-pill">{car.driveType}</p>
              <p className="content-pill">{car.fuelType}</p>
              <p className="content-pill">{car.mileage}</p>
              <p className="content-pill">{car.yearOfRegistration}</p>
            </div>
            <div className="car-card-price-container">
              <div className="car-card-price-text">Price</div>
              <div className="car-card-price">{car.price}€</div>
            </div>
            <div className="division-line"></div>
            {hasValidUser(shownUser) && (
              <>
                <div className="persons-list-description">
                  {renderIcon("person")}Tätä autoa myy
                </div>
                {<PersonCard person={convertUserToPerson(shownUser)} />}
                <div className="contact-butons-container">
                  <div className="persons-list-description">
                    {renderIcon("phone")}Kiinnostuitko?
                  </div>
                  <button
                    className="contact-button wapp"
                    onClick={() => contactWhatsapp(shownUser)}
                  >
                    Ota yhteyttä WhatsAppilla {renderButtonIcon("wapp")}
                  </button>
                  <button
                    onClick={() => contactCall(shownUser)}
                    className="contact-button phone"
                  >
                    Soita {shownUser?.phone} {renderButtonIcon("phone")}
                  </button>
                  <button
                    onClick={() => contactEmail(shownUser)}
                    className="contact-button message"
                  >
                    Ota yhteyttä sähköpostitse {renderButtonIcon("message")}
                  </button>
                </div>
              </>
            )}
          </div>
        </RightSidebar>
        )}
        <CarInformation car={car} />
      </div>
      {!isMobile && (
        <RightSidebar>
          <div className="car-card-content right-sidebar">
            <div className="back-button" onClick={() => navigate("/cars")}>
              {renderIcon("back")} Takaisin listaukseen
            </div>
            <div className="car-card-header">
              <div className="car-card-title">
                <div className="car-card-make-model">
                  {car.make} {car.model}
                </div>
                <div className="car-card-year">{car.yearOfRegistration}</div>
              </div>
              <div className="car-card-description">{car.modelTypeName}</div>
            </div>
            <div className="car-card-items">
              <p className="content-pill">{car.driveType}</p>
              <p className="content-pill">{car.fuelType}</p>
              <p className="content-pill">{car.mileage}</p>
              <p className="content-pill">{car.yearOfRegistration}</p>
            </div>
            <div className="car-card-price-container">
              <div className="car-card-price-text">Price</div>
              <div className="car-card-price">{car.price}€</div>
            </div>
            <div className="division-line"></div>
            {hasValidUser(shownUser) && (
              <>
                <div className="persons-list-description">
                  {renderIcon("person")}Tätä autoa myy
                </div>
                {<PersonCard person={convertUserToPerson(shownUser)} />}
                <div className="contact-butons-container">
                  <div className="persons-list-description">
                    {renderIcon("phone")}Kiinnostuitko?
                  </div>
                  <button
                    className="contact-button wapp"
                    onClick={() => contactWhatsapp(shownUser)}
                  >
                    Ota yhteyttä WhatsAppilla {renderButtonIcon("wapp")}
                  </button>
                  <button
                    onClick={() => contactCall(shownUser)}
                    className="contact-button phone"
                  >
                    Soita {shownUser?.phone} {renderButtonIcon("phone")}
                  </button>
                  <button
                    onClick={() => contactEmail(shownUser)}
                    className="contact-button message"
                  >
                    Ota yhteyttä sähköpostitse {renderButtonIcon("message")}
                  </button>
                </div>
              </>
            )}
          </div>
        </RightSidebar>
      )}
    </>
  );
};
export default CarItem;
